import React, { Component } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import Theme from 'Theme';
import { mapBreakPoints } from 'utils';
import { BREAK_POINTS } from 'constants/app';

export class ThemeProvider extends Component {
  constructor(props) {
    super(props);

    this.setTheme = this.setTheme.bind(this);
    this.resetTheme = this.resetTheme.bind(this);

    this.state = {
      ...Theme,
      setTheme: this.setTheme,
      resetTheme: this.resetTheme,
      media: mapBreakPoints(BREAK_POINTS)
    };
  }

  resetTheme() {
    this.setTheme(Theme);
  }

  setTheme(theme) {
    this.setState(() => ({ ...theme }));
  }

  render() {
    const { children } = this.props;

    return <StyledThemeProvider theme={this.state}>{children}</StyledThemeProvider>;
  }
}

export default ThemeProvider;
